<highcharts-chart [options]="chartOptions()" (chartInstance)="chartInstance = $event"/>